module.exports = __webpack_public_path__ + "img/14.e3d738c0.png";